import React, { Component, Fragment } from "react";
import "./complaint.css";

import Page from "../../components/page/page";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";
import Auth from "../../services/authService";
import ComplaintService from "../../services/complaintService";
import LoadingSpinner from "../../components/loader/LoadingSpinner";
import { toast } from "react-toastify";

const user = Auth.getCurrentUser();

export default class complaint extends Component {

    state = {
        isLoading: false,
        userComplaintItems: [],
        complaintsCount:0
    };

    async componentDidMount() {
        const user = Auth.getCurrentUser();
        try {
            const state = { ...this.state };
            const result =
                await ComplaintService.ComplaintsList(
                    user.customerid
                );
            state.userComplaintItems = result;
            const isLoading = true;
            state.isLoading = isLoading;
            state.complaintsCount = state.userComplaintItems.length;
            this.setState(state);
        } catch (ex) {
            if (ex.code !== "ERR_NETWORK") {
                if (ex.code !== "ERR_BAD_REQUEST")
                    toast.error(ex.response.data.Message);
            }
        }
    }

    render() {
        if (!Auth.getCurrentUser()) return (window.location = "/login");
        return (
            <Page>
                <Header />
                <section className="container">
                    <div className="row hrow headbox-dark">
                        <h3 className="title">ليست شکایت های شما</h3>
                    </div>
                    {this.state.isLoading ? (
                        <Fragment>
                            <p className="d-flex justify-content-center align-items-center p-2"> {this.state.complaintsCount} شکایت ثبت شده در سامانه</p>
                            <div>
                                {this.state.userComplaintItems.map((item) => (
                                    <div className="row hrow" key={item.id}>
                                        <div className="productitme ComplaintItem">
                                            <div className="c-date"><span className="m-2">نام ارائه کننده شکایت : </span>{item.contactInfoResponserFullName}</div>
                                            <div className="c-date"><span className="m-2">موضوع شکایت :</span></div>
                                            <p>
                                                {item.raisedSubjects}
                                            </p>
                                            <div className="c-date"><span className="m-2">کد پیگیری : </span>{item.trackingCode}</div>
                    
                                            <div className="c-date"><span className="m-2">تاریخ ثبت :</span> {item.completionDateInText}</div>
                                        
                                            <span className="status">وضعیت : {item.complaintStatus}</span>
                                        </div>     
                                    </div>
                                ))}
                            </div>
                        </Fragment>
                    ) : (
                        <LoadingSpinner />
                    )}
                </section>
                <Footer />
            </Page>
        );
    }
}
